"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _Anchor = _interopRequireDefault(require("../../../Atoms/Anchor"));
var _V2NavL2Panel = _interopRequireDefault(require("./V2NavL2Panel"));
var _screenSizes = _interopRequireDefault(require("../../../../core/utils/screenSizes"));
var _navUtils = require("./../nav-utils");

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */
var V2NavL1Item = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2.default)(V2NavL1Item, _React$PureComponent);
  function V2NavL1Item() {
    var _this;
    _this = _React$PureComponent.call(this) || this;
    _this.navL1WindowResizeEventHandler = function () {
      _this.isMobileSize = _screenSizes.default.isMobile();
    };
    _this.onMouseHover = function (hasL2) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handleNavigationDrawer = _this.props.handleNavigationDrawer;
        if (!_this.isMobileSize) {
          clearTimeout(_this.timeOutHandler);
          _this.timeOutHandler = setTimeout(function () {
            if (!hasL2) {
              _this.setMouseHoveredState(true);
            } else {
              _this.setMouseHoveredState(true, handleNavigationDrawer);
            }
          }, 0);
        }
        if (!_this.isMobileSize) {
          (0, _navUtils.handleScrollOnHover)(hasL2);
        }
      };
    };
    _this.setMouseHoveredState = function (isHovered, handleNavigationDrawer) {
      if (handleNavigationDrawer === void 0) {
        handleNavigationDrawer = function handleNavigationDrawer() {
          /* default handleNavigationDrawer handler */
        };
      }
      _this.setState({
        hoveredState: isHovered
      }, function () {
        handleNavigationDrawer(isHovered);
      });
    };
    _this.onMouseLeaveEvent = function () {
      var handleNavigationDrawer = _this.props.handleNavigationDrawer;
      clearTimeout(_this.timeOutHandler);
      _this.timeOutHandler = setTimeout(function () {
        _this.setMouseHoveredState(false, handleNavigationDrawer);
      }, 0);
    };
    _this.openNavDrawer = function (hasL2) {
      return function (e) {
        var handleNavigationDrawer = _this.props.handleNavigationDrawer;
        var hoveredState = _this.state.hoveredState;
        if (_this.isMobileSize) {
          if (hasL2) {
            e.preventDefault();
            e.stopPropagation();
            var hoveredStatus = _this.isMobileSize ? !hoveredState : true;
            clearTimeout(_this.timeOutHandler);
            _this.timeOutHandler = setTimeout(function () {
              _this.setMouseHoveredState(hoveredStatus, handleNavigationDrawer);
            }, 0);
          }
        } else {
          clearTimeout(_this.timeOutHandler);
          _this.setMouseHoveredState(false);
        }
      };
    };
    _this.state = {
      hoveredState: false
    };
    _this.isMobileSize = _screenSizes.default.isMobile();
    _this.timeOutHandler = null;
    _this.navL1WindowResizeEventHandler = _this.navL1WindowResizeEventHandler.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  var _proto = V2NavL1Item.prototype;
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.navL1WindowResizeEventHandler);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.navL1WindowResizeEventHandler);
  };
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      dataLocator = _this$props.dataLocator,
      navL1Item = _this$props.navL1Item,
      hasL2 = _this$props.hasL2,
      xfNavHtml = _this$props.xfNavHtml;
    var title = navL1Item.title,
      url = navL1Item.url,
      _navL1Item$level = navL1Item.level,
      level = _navL1Item$level === void 0 ? 0 : _navL1Item$level;
    var hoveredState = this.state.hoveredState;
    var isMobileActive = hoveredState && this.isMobileSize ? 'is-active' : '';
    return _react.default.createElement("li", {
      className: className + " cmp-navigation__item--level-" + level + " " + isMobileActive,
      onMouseEnter: this.onMouseHover(hasL2),
      onMouseLeave: this.onMouseLeaveEvent,
      id: dataLocator,
      role: "menuitem",
      "data-locator": dataLocator
    }, _react.default.createElement("div", {
      className: "cmp-navigation__container",
      onClick: this.openNavDrawer(hasL2)
    }, _react.default.createElement(_Anchor.default, {
      className: "cmp-navigation__item-link",
      to: url,
      as: url,
      title: title,
      "aria-label": title
    }, title)), hasL2 && _react.default.createElement(_V2NavL2Panel.default, {
      className: "cmp-navigation__group-wrapper",
      path: url,
      name: title,
      xfNavHtml: xfNavHtml
    }));
  };
  return V2NavL1Item;
}(_react.default.PureComponent);
V2NavL1Item.defaultProps = {
  dataLocator: ''
};
var _default = V2NavL1Item;
exports.default = _default;
module.exports = exports["default"];